
import {IGraphAxis, IGraphMetric} from "../PA.UIM.Metric/PA.UIM.Graph.IF";
import {
  CNSMP_LIST_PRICE,
  CNSMP_RETAILER_AVG_PRICE,
  CNSMP_RETAILER_PROMOTED_PRICE, StdMerchadisingACVAxis, StdMerchadisingUnitsAxis, StdPricesAxis, StdUnitsAxis
} from "../PA.UIM.Metric/StandardGraphComponents";

//
// Define Metrics for each Axis
//

//<editor-fold desc="EDLP Analysis - Consumer Units Axis">

//<editor-fold desc="EDLP Analysis - Consumer Units Axis - Metrics">



const CNSMP_EDLP_UNITS_UseBounds_EDLPMdl: IGraphMetric = {
  id: "CNSMP_EDLP_UNITS_UseBounds_EDLPMdl",
  name: "Model EDLP Units",
  sort: 20,
  renderOptions: {},
  components: [
    {id: "CNSMP_EDLP_UNITS_InsideBounds_EDLPMdl",
      name: "InsideBounds Model EDLP Units",
      metricFieldName: "CNSMP_EDLP_UNITS",
      periodMetricsPath: "CalcInsideBounds",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"CNSMP_EDLP_UNITS_InsideBounds_EDLPMdl": '*'},
            properties: {color : "#0080FF"},
            displayName: "InsideBounds Model EDLP Units"
          }
        }
      }
    },
    {id: "CNSMP_EDLP_UNITS_OutsideBounds_EDLPMdl",
      name: "OutsideBounds Model EDLP Units",
      metricFieldName: "CNSMP_EDLP_UNITS",
      periodMetricsPath: "CalcOutsideBounds",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"CNSMP_EDLP_UNITS_OutsideBounds_EDLPMdl": '*'},
            properties: {color : "#0080FF",  pattern : "diagonalLightStripe"},
            displayName: "OutsideBounds Model EDLP Units"
          }
        }
      }
    }
  ]
}


const CNSMP_BASE_UNITS_UseBounds_EDLPMdl: IGraphMetric = {
  id: "CNSMP_BASE_UNITS_UseBounds_EDLPMdl",
  name: "Model True Base Units",
  sort: 40,
  renderOptions: {},
  components: [
    {id: "CNSMP_BASE_UNITS_InsideBounds_EDLPMdl",
      name: "InsideBounds Model True Base Units",
      metricFieldName: "CNSMP_BASE_UNITS",
      periodMetricsPath: "CalcInsideBounds",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"CNSMP_BASE_UNITS_InsideBounds_EDLPMdl": '*'},
            properties: {color : "#A59487"},
            displayName: "InsideBounds Model True Base Units"
          }
        }
      }
    },
    {id: "CNSMP_BASE_UNITS_OutsideBounds_EDLPMdl",
      name: "OutsideBounds Model True Base Units",
      metricFieldName: "CNSMP_BASE_UNITS",
      periodMetricsPath: "CalcOutsideBounds",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"CNSMP_BASE_UNITS_OutsideBounds_EDLPMdl": '*'},
            properties: {color : "#A59487",  pattern : "diagonalLightStripe"},
            displayName: "OutsideBounds Model True Base Units"
          }
        }
      }
    }
  ]
}


const CNSMP_SYND_BASE_UNITS_UseBounds_EDLPMdl: IGraphMetric = {
  id: "CNSMP_SYND_BASE_UNITS_UseBounds_EDLPMdl",
  name: "Synd Base Units",
  sort: 30,
  renderOptions: {},
  components: [
    {id: "CNSMP_SYND_BASE_UNITS_InsideBounds_EDLPMdl",
      name: "InsideBounds Synd Base Units",
      metricFieldName: "CNSMP_SYND_BASE_UNITS",
      periodMetricsPath: "CalcInsideBounds",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"CNSMP_SYND_BASE_UNITS_InsideBounds_EDLPMdl": '*'},
            properties: {color : "#A59487"},
            displayName: "InsideBounds Synd Base Units"
          }
        }
      }
    },
    {id: "CNSMP_SYND_BASE_UNITS_OutsideBounds_EDLPMdl",
      name: "OutsideBounds Synd Base Units",
      metricFieldName: "CNSMP_SYND_BASE_UNITS",
      periodMetricsPath: "CalcOutsideBounds",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"CNSMP_SYND_BASE_UNITS_OutsideBounds_EDLPMdl": '*'},
            properties: {color : "#A59487",  pattern : "diagonalLightStripe"},
            displayName: "OutsideBounds Synd Base Units"
          }
        }
      }
    }
  ]
}

//</editor-fold>

export const  EDLPModelUnitsAxis: IGraphAxis = {
  id: "EDLP_Model_Units",
  name: "EDLP Model - Consumer Units",
  renderOptions: {ui5: {
      resourceName: "EDLPModelConsumerUnitsAxisName",
      vizPropertiesAxis: {
        title: {
          visible: true,
          text: "Consumer Units"
        }
      },
      vizPropertiesPlotArea: {}
    }
  },
  metrics: [CNSMP_EDLP_UNITS_UseBounds_EDLPMdl, CNSMP_BASE_UNITS_UseBounds_EDLPMdl, CNSMP_SYND_BASE_UNITS_UseBounds_EDLPMdl],
  defaultRenderedMetricIds: [
    CNSMP_EDLP_UNITS_UseBounds_EDLPMdl.id,
    CNSMP_BASE_UNITS_UseBounds_EDLPMdl.id
  ]

}

//</editor-fold>



//<editor-fold desc="EDLP Analysis - Prie Axis">

//<editor-fold desc="EDLP Analysis - Price Axis - Metrics">


const TRUE_BASE_PRICE_EDLPMdl: IGraphMetric = {
  id: "TRUE_BASE_PRICE_EDLPMdl",
  name: "True Base Price",
  sort: 100,
  renderOptions: {},
  components: [
    {id: "TRUE_BASE_PRICE_EDLPMdl",
      name: "True Base Price",
      metricFieldName: "TRUE_BASE_PRICE",
      periodMetricsPath: "CalcTotal",
      renderOptions: {ui5: { dataShape: "line",
          dataPointRule: {
            dataContext: {"TRUE_BASE_PRICE_EDLPMdl": '*'},
            properties: {color : "#0080FF", lineColor : "#0080FF", lineType : "line"},
            displayName: "True Base Price"
          }
        }
      }
    }
  ]
}


const OBSERVED_BASE_PRICE_EDLPMdl: IGraphMetric = {
  id: "OBSERVED_BASE_PRICE_EDLPMdl",
  name: "Observed Base Price",
  sort: 200,
  renderOptions: {},
  components: [
    {id: "OBSERVED_BASE_PRICE_EDLPMdl",
      name: "Observed Base Price",
      metricFieldName: "OBSERVED_BASE_PRICE",
      periodMetricsPath: "CalcTotal",
      renderOptions: {ui5: { dataShape: "line",
          dataPointRule: {
            dataContext: {"OBSERVED_BASE_PRICE_EDLPMdl": '*'},
            properties: {color : "#A59487", lineColor : "#A59487", lineType : "line"},
            displayName: "Observed Base Price"
          }
        }
      }
    }
  ]
}


//</editor-fold>

export const  EDLPModelPriceAxis: IGraphAxis = {
  id: "EDLP_Model_Price",
  name: "EDLP Model - Prices",
  renderOptions: {ui5: {
      resourceName: "EDLPModelPriceAxisName",
      vizPropertiesAxis: {
        title: {
          visible: true,
          text: "Price"
        },
        label : {
          formatString : "0.00"
        }
      },
      vizPropertiesPlotArea: {}
    }
  },
  metrics: [TRUE_BASE_PRICE_EDLPMdl,
            OBSERVED_BASE_PRICE_EDLPMdl,
            CNSMP_RETAILER_PROMOTED_PRICE,
            CNSMP_RETAILER_AVG_PRICE,
            CNSMP_LIST_PRICE
  ],
  defaultRenderedMetricIds: [
    TRUE_BASE_PRICE_EDLPMdl.id,
    OBSERVED_BASE_PRICE_EDLPMdl.id
  ]

}

//</editor-fold>


//<editor-fold desc="EDLP Analysis - Discount and Lift Axis">

//<editor-fold desc="EDLP Analysis - Discount and Lift Axis - Metrics">

const BASE_DISCOUNT_PCNT_EDLPMdl: IGraphMetric = {
  id: "BASE_DISCOUNT_PCNT_EDLPMdl",
  name: "Base Discount Pcnt",
  sort: 100,
  renderOptions: {},
  components: [
    {id: "BASE_DISCOUNT_PCNT_EDLPMdl",
      name: "Base Discount Pcnt",
      metricFieldName: "BASE_DISCOUNT_PCNT",
      periodMetricsPath: "CalcTotal",
      renderOptions: {ui5: { dataShape: "line",
          dataPointRule: {
            dataContext: {"BASE_DISCOUNT_PCNT_EDLPMdl": '*'},
            properties: {color : "#FFB019", lineColor : "#FFB019", lineType : "line"},
            displayName: "Base Discount Pcnt"
          }
        }
      }
    }
  ]
}

const EDLP_LIFT_PCNT_EDLPMdl: IGraphMetric = {
  id: "EDLP_LIFT_PCNT_EDLPMdl",
  name: "EDLP Lift Pcnt",
  sort: 100,
  renderOptions: {},
  components: [
    {id: "EDLP_LIFT_PCNT_EDLPMdl",
      name: "ELDP Lift Pcnt",
      metricFieldName: "EDLP_LIFT_PCNT",
      periodMetricsPath: "CalcTotal",
      renderOptions: {ui5: { dataShape: "line",
          dataPointRule: {
            dataContext: {"EDLP_LIFT_PCNT_EDLPMdl": '*'},
            properties: {color : "#14A5FF", lineColor : "#14A5FF", lineType : "line"},
            displayName: "EDLP Lift Pcnt"
          }
        }
      }
    }
  ]
}




//</editor-fold>


export const  EDLPModelDiscountLiftAxis: IGraphAxis = {
  id: "EDLP_Model_DiscountLift",
  name: "EDLP Model - Discount, Lift",
  renderOptions: {ui5: {
      resourceName: "EDLPModelDiscountLiftAxisName",
      vizPropertiesAxis: {
        title: {
          visible: true,
          text: "Discount/ Lift"
        },
        label : {
          formatString : "0\\%"
        }
      },
      vizPropertiesPlotArea: {}
    }
  },
  metrics: [
    BASE_DISCOUNT_PCNT_EDLPMdl,
    EDLP_LIFT_PCNT_EDLPMdl
  ],
  defaultRenderedMetricIds: [
    BASE_DISCOUNT_PCNT_EDLPMdl.id,
    EDLP_LIFT_PCNT_EDLPMdl.id
  ]

}

export const EDLPAnalysisAxisList: IGraphAxis[] = [
  EDLPModelUnitsAxis,
  EDLPModelPriceAxis,
  EDLPModelDiscountLiftAxis
]

//</editor-fold>

